function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_654_255)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.0287 17.5C10.8162 17.5 10.6382 17.4281 10.4945 17.2843C10.3507 17.1404 10.2787 16.9623 10.2787 16.7498C10.2787 16.5371 10.3507 16.359 10.4945 16.2155C10.6382 16.0718 10.8162 16 11.0287 16H12.9615C13.174 16 13.3522 16.0719 13.496 16.2158C13.6397 16.3596 13.7115 16.5378 13.7115 16.7503C13.7115 16.9629 13.6397 17.141 13.496 17.2845C13.3522 17.4282 13.174 17.5 12.9615 17.5H11.0287ZM7.15375 12.75C6.94125 12.75 6.76317 12.6781 6.6195 12.5342C6.47583 12.3904 6.404 12.2122 6.404 11.9997C6.404 11.7871 6.47583 11.609 6.6195 11.4655C6.76317 11.3218 6.94125 11.25 7.15375 11.25H16.8365C17.049 11.25 17.2272 11.3219 17.371 11.4658C17.5147 11.6096 17.5865 11.7878 17.5865 12.0003C17.5865 12.2129 17.5147 12.391 17.371 12.5345C17.2272 12.6782 17.049 12.75 16.8365 12.75H7.15375ZM4.25 8C4.0375 8 3.85942 7.92808 3.71575 7.78425C3.57192 7.64042 3.5 7.46225 3.5 7.24975C3.5 7.03708 3.57192 6.859 3.71575 6.7155C3.85942 6.57183 4.0375 6.5 4.25 6.5H19.75C19.9625 6.5 20.1406 6.57192 20.2843 6.71575C20.4281 6.85958 20.5 7.03775 20.5 7.25025C20.5 7.46292 20.4281 7.641 20.2843 7.7845C20.1406 7.92817 19.9625 8 19.75 8H4.25Z",
  fill: "#707274"
}));

function SvgMorefilters(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_654_255",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorefilters);
export default __webpack_public_path__ + "static/media/More filters.f5350fa8.svg";
export { ForwardRef as ReactComponent };